module.exports = __webpack_public_path__ + "asset/image-ic_category_28-ba74c956489e927c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_28.svg
// module id = waoX
// module chunks = 0